import {Component} from '@angular/core';

@Component({
   selector: 'app-action',
   templateUrl: './action.component.html',
   styleUrls: ['./action.component.css']
})
export class ActionComponent {

}
